export default __webpack_public_path__ + "static/media/solidario3.42e0852f.jpeg";